// src/screens/TourGroupsCalendar.js
import styled from "styled-components";
import Header from "../components/header/Header";
import TourGroupsCalendarContent from "../components/tour_groups_calendar/content/TourGroupsCalendarContent";
import { useNavigate } from "react-router-dom";

//-------------------------------------------------

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const ContentContainer = styled.div`
  flex: 1;
  display: flex;
  overflow: hidden;
`;

//-------------------------------------------------

const TourGroupsCalendar = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <Header
        text={"Tour Groups Calendar"}
        redirectFn={() => {
          navigate("/home");
        }}
      />
      <ContentContainer>
        <TourGroupsCalendarContent />
      </ContentContainer>
    </Container>
  );
};

export default TourGroupsCalendar;
